import { Col, Row } from 'antd';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import AuthList from './components/AuthList';

const AdminAuthSetting = () => {
  return (
    <Row>
      <Col span={24}>
        <PageHeader
          title="管理員帳號權限設定"
          breadcrumbs={[
            {
              name: '帳號管理',
            },
            {
              name: '管理員帳號權限設定',
            },
          ]}
        />
        <AuthList />
      </Col>
    </Row>
  );
};

export default AdminAuthSetting;
